// extracted by mini-css-extract-plugin
module.exports = {"parentcontainer":"glb_parentcontainer__LPTOG","container":"glb_container__QB8YW","button":"glb_button__mQnU7","paragraph":"glb_paragraph__T8KvE"};